exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'EUROCAPS';\n  src: url(" + require("../assets/font/EUROCAPS.TTF") + ");\n}\n\n@font-face {\n  font-family: 'CenturyGothicRegular';\n  src: url(" + require("../assets/font/CenturyGothicRegular.ttf") + ");\n}\n\n@font-face {\n  font-family: 'Telegren';\n  src: url(" + require("../assets/font/telegren.ttf") + ");\n}\n\n@font-face {\n  font-family: 'Sintony-Regular';\n  src: url(" + require("../assets/font/Sintony-Regular.ttf") + ");\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n}\n\n.b-container {\n  background: black;\n  flex: 1\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/styles/index.css
// module id = 722
// module chunks = 0